import React, { createContext, useContext, useEffect, useState } from "react";
import { http, formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await http.get("/auth/me");
                setUser(data);
            } catch {
                setUser(null);
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    async function login(email, password) {
        try {
            const { data } = await http.post("/auth/login", { email, password });
            if (data.token) localStorage.setItem("br_token", data.token);
            setUser(data.user);
            return { ok: true };
        } catch (e) {
            return { ok: false, error: formatApiError(e) };
        }
    }

    async function register(email, password, name) {
        try {
            const { data } = await http.post("/auth/register", { email, password, name });
            if (data.token) localStorage.setItem("br_token", data.token);
            setUser(data.user);
            return { ok: true };
        } catch (e) {
            return { ok: false, error: formatApiError(e) };
        }
    }

    async function logout() {
        try { await http.post("/auth/logout"); } catch { /* ignore */ }
        localStorage.removeItem("br_token");
        setUser(null);
    }

    return (
        <AuthContext.Provider value={{ user, loading, login, register, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
